import React from 'react';

// Renders the staff sender's signature (avatar + name + title + NMLS) under a
// non-borrower message. Reads the sender_* fields the messages API joins from
// the users table. Returns null for borrower messages or when there's no
// resolvable staff name.
export function MessageSignature({ sender }) {
  if (!sender) return null;
  // EXPLICIT, not incidental. Eva rows currently resolve no name (the messages
  // JOIN is ON sender_role='support', so sender_* comes back NULL) and would
  // bail at the !name guard below by luck. Relying on that is unacceptable for
  // this particular component: it renders a job title and an NMLS number, and an
  // AI answer must NEVER carry a licensed originator's credentials. If a future
  // change ever populates those fields, this line is what still stops it.
  if (sender.sender_role === 'borrower' || sender.sender_role === 'eva') return null;

  const name = [sender.sender_first_name, sender.sender_last_name]
    .filter(Boolean).join(' ').trim() || sender.sender_name || '';
  if (!name) return null;

  const title = sender.sender_title || sender.sender_job_title || sender.sender_role_internal || '';
  const nmls = sender.sender_nmls || '';
  // Only a data: / https photo — a legacy server path pointed at the closed public file mount (2026-10-28).
  const photo = /^(data:image\/|https:\/\/)/.test(sender.sender_photo || '') ? sender.sender_photo : '';
  const initials = name.split(/\s+/).map((n) => n[0]).join('').toUpperCase().slice(0, 2);

  return (
    <div style={{
      marginTop: 10, paddingTop: 8, borderTop: '1px solid rgba(0,0,0,0.08)',
      display: 'flex', alignItems: 'center', gap: 8,
    }}>
      {photo ? (
        <img src={photo} alt={name}
          style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
      ) : (
        <div style={{
          width: 28, height: 28, borderRadius: '50%', background: '#3a6ad9', color: '#fff',
          fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center',
          justifyContent: 'center', flexShrink: 0,
        }}>{initials}</div>
      )}
      <div>
        <div style={{ fontSize: 12, fontWeight: 600, color: '#111827', lineHeight: 1.3 }}>{name}</div>
        {title && (
          <div style={{ fontSize: 11, color: '#6b7280', lineHeight: 1.3 }}>
            {title}
            {nmls && <span style={{ marginLeft: 4 }}>· NMLS #{nmls}</span>}
          </div>
        )}
      </div>
    </div>
  );
}
